import React from 'react'
import './loading.scss'

const Loading = () => {
  return (
    <div className="loading">
      <h1>LOADING...</h1>
    </div>
  )
}

export default Loading
